import { render, staticRenderFns } from "./CardBase.vue?vue&type=template&id=10a9bec8&scoped=true&"
var script = {}
import style0 from "./CardBase.vue?vue&type=style&index=0&id=10a9bec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a9bec8",
  null
  
)

export default component.exports